import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { UiWidget } from '@pt/pt-models';
import { NgbAccordionDirective, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { JsonPipe, NgClass, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PtWidgetModuleConfig, WidgetConfig } from '@pt/pt-core';

@Component({
  selector: 'pt-dev-widget-info',
  standalone: true,
  template: `
    <div ngbAccordion #accordion="ngbAccordion" class="border-0" *ngIf="widget">
      <div ngbAccordionItem="first" #first="ngbAccordionItem" [collapsed]="true" class="border-0">
        <div ngbAccordionHeader class="accordion-button custom-header justify-content-between border-0" ngbAccordionToggle>
          <div class="d-flex align-items-center justify-content-between w-100 btn-dev-more">
            <div class="d-flex align-items-center font-12 gap-2">
              <div class='badge rounded-pill bg-secondary text-white ms-1'>
                InternalId: {{ widget.internalId }}
              </div>
              <div class="d-flex fw-bold">{{ widget.label }}</div>
            </div>

            <div class="d-flex align-items-center font-12 gap-2">
              <div class='badge rounded-pill bg-warning text-dark'>
                {{ widget.type }}
              </div>
              <div class='badge rounded-pill' [ngClass]="widget.enabled ? 'bg-success' : 'bg-danger'">
                Enabled: <b>{{ widget.enabled }}</b>
              </div>
              <div class='badge rounded-pill' [ngClass]="widget.opt ? 'bg-success' : 'bg-danger'">
                Opt: <b>{{ widget.opt }}</b>
              </div>
            </div>
          </div>
        </div>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <pre class="font-12">{{ widget | json }}</pre>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  `,
  imports: [
    NgbAccordionDirective,
    NgbAccordionModule,
    JsonPipe,
    TranslateModule,
    NgIf,
    NgClass
  ],
  styles: [
    `
      .btn-dev-more {
        cursor: pointer;
      }

      .custom-header {
        width: 100%;
        padding: 0 11px !important;
        background: #ffffff;
        border-bottom: 2px solid #cccccc !important;
        border-radius: 0 !important;
        cursor: pointer;
        opacity: 0.3;
      }
      .custom-header > * {
        cursor: pointer;
      }

      .custom-header:hover {
        opacity: 1;
        /*border-bottom: 2px solid #990000 !important;*/
      }

      .custom-header::after {
        content: none;
      }

      .custom-header p {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 12px;
      }

      .custom-header p > * {
        margin-left: 5px;
      }
    `
  ],
  encapsulation: ViewEncapsulation.None,
})
export class DevWidgetInfoComponent {
  @Input() widget?: UiWidget;
  isDev: boolean;

  constructor(@Inject(WidgetConfig) public config: PtWidgetModuleConfig) {
    this.isDev = !config?.env?.production;
  }

}
